import { FILTER_QUERY_PARAMS, DEALS_FILTER_VALUES } from 'site-modules/shared/constants/lease-deals/lease-deals';

export const getListTrackingCreativeId = selectedFilters => {
  const deals = selectedFilters[FILTER_QUERY_PARAMS.DEALS]?.[0];
  const isGemView = deals === DEALS_FILTER_VALUES.GEMS;

  return isGemView ? 'edm-lease-deals-hidden-gems' : 'edm-lease-deals-all-specials';
};
